import React, { useState } from 'react';
import { useInterestList } from '../context/InterestListContext';
import { useAuthContext } from '../context/AuthContext';
import { API_ENDPOINTS } from '../config/api';

export const Auth = ({ initialMode = 'login' }) => {
  const [isLogin, setIsLogin] = useState(initialMode === 'login');
  const [username, setUsernameInput] = useState('');
  const [email, setEmailInput] = useState('');
  const [phone, setPhoneInput] = useState('');
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  
  const { onLogin } = useInterestList();
  const { login } = useAuthContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isLogin) {
        // Login usando o contexto de autenticação
        const result = await login(identifier, password);
        
        if (result.success) {
          setMsg('Login efetuado com sucesso!');
          
          // Notificar contexto sobre login
          onLogin(identifier);
          
        } else {
          setMsg(result.error || 'Erro no login');
        }
      } else {
        // Registo: continua usando fetch direto
        const res = await fetch(API_ENDPOINTS.REGISTER, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, email, phone, password }),
        });
        const data = await res.json();
        if (data.status === 'ok') {
          setMsg('Registo efetuado com sucesso! Faça login.');
          setIsLogin(true);
        } else {
          setMsg(data.error || 'Erro');
        }
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
      setMsg('Erro de conexão. Verifique se o servidor está rodando.');
    }
  };

  return (
    <div className="auth-container">
      <h2>{isLogin ? 'Login' : 'Registo'}</h2>
      <form onSubmit={handleSubmit}>
        {isLogin ? (
          <>
            <input
              type="text"
              placeholder="Username, Email ou Telemóvel"
              value={identifier}
              onChange={e => setIdentifier(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Senha"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </>
        ) : (
          <>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={e => setUsernameInput(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmailInput(e.target.value)}
              required
            />
            <input
              type="tel"
              placeholder="Número de Telemóvel"
              value={phone}
              onChange={e => setPhoneInput(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Senha"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </>
        )}
        <button type="submit">{isLogin ? 'Entrar' : 'Registar'}</button>
      </form>
      <button className="toggle-btn" onClick={() => setIsLogin(!isLogin)}>
        {isLogin ? 'Criar conta' : 'Já tenho conta'}
      </button>
      <p className="auth-msg">{msg}</p>
    </div>
  );
};